import styled from 'styled-components';

export const MainLayoutWrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
`;
